// extracted by mini-css-extract-plugin
export default {"modal":"AiNoticeModal_modal__jUFOi","content":"AiNoticeModal_content__nI6KZ","actions":"AiNoticeModal_actions__vIhEF","likeAnimation":"AiNoticeModal_likeAnimation__Ajz1i"};